import { gql } from "@apollo/client";

export const GET_DOCUMENTOS_BY_CODIGO_SAP = gql`
query GetDocumentosByCodigoSap($codigoSAP: String!, $idPlanCuidado: Int!) {
    documentosByCodigoSap(codigoSAP: $codigoSAP, idPlanCuidado: $idPlanCuidado) {
        idDocumentoMinuta,
        descripcion
    }
}
`;

export const adaptDocumentosByCodigoSap = (documento) => {
  return {
    idDocumentoMinuta: documento?.idDocumentoMinuta,
    descripcion: documento?.descripcion
  };
};

export const adaptDocumentosByCodigoSapArray = (documentos) => {
  return structuredClone(documentos)?.
  map((documento) => adaptDocumentosByCodigoSap(documento));
};